import PropTypes from 'prop-types'
import { isNil } from 'ramda'

class DoctorSpecialty {
  constructor(init) {
    // console.log('> DoctorSpecialty constructor -', init)
    if (isNil(init)) return undefined
    this._classification = init.classification
    this._detailed_description = init.detailed_description
    this._name = init.name
    this._uid = init.uid
  }

  static shape = {
    classification: PropTypes.string,
    detailed_description: PropTypes.string,
    name: PropTypes.string,
    uid: PropTypes.string
  }

  get classification() {
    return this._classification || ''
  }

  get detailed_description() {
    return this._detailed_description || ''
  }

  get name() {
    return this._name || ''
  }

  get uid() {
    return this._uid || ''
  }
}

export default DoctorSpecialty
